import { rtdb } from "../../services/firebase/rtdb";
import {
  ref,
  get,
  set,
  update,
  onValue,
} from "firebase/database";

export function listenOrganizerRequests({ status = "pending" } = {}, cb) {
  const requestsRef = ref(rtdb, "organizerRequests");
  return onValue(requestsRef, (snap) => {
    if (!snap.exists()) {
      cb([]);
      return;
    }
    const rows = Object.entries(snap.val())
      .map(([id, data]) => ({ id, ...data }))
      .filter((r) => (status ? r.status === status : true))
      .sort((a, b) => (b.createdAtMs || 0) - (a.createdAtMs || 0));
    cb(rows);
  });
}

export async function getOrganizerRequest(id) {
  const snap = await get(ref(rtdb, `organizerRequests/${id}`));
  if (!snap.exists()) return null;
  return { id, ...snap.val() };
}

function buildReview(reviewerUid, notes) {
  return {
    by: reviewerUid || "admin-local",
    notes: notes || "",
    atMs: Date.now(),
  };
}

async function resolveTargetUid(requestId) {
  const snap = await get(ref(rtdb, `organizerRequests/${requestId}`));

  if (!snap.exists()) {
    throw new Error(`Solicitação ${requestId} não encontrada.`);
  }

  const data = snap.val();
  const targetUid = data.uid || requestId;

  return { requestData: data, targetUid };
}

export async function approveOrganizerRequest(
  id,
  { reviewerUid, notes = "" } = {},
) {
  const { requestData, targetUid } = await resolveTargetUid(id);
  const review = buildReview(reviewerUid, notes);

  await update(ref(rtdb, `organizerRequests/${id}`), {
    status: "approved",
    review,
    approvedAtMs: Date.now(),
    updatedAtMs: Date.now(),
  });

  await update(ref(rtdb, `users/${targetUid}`), {
    uid: targetUid,
    name: requestData?.organizer?.name || "",
    email: requestData?.organizer?.email || "",
    phone: requestData?.organizer?.phone || "",
    role: "organizer",
    approvalStatus: "approved",
    active: true,
    updatedAtMs: Date.now(),
  });
}

export async function rejectOrganizerRequest(
  id,
  { reviewerUid, notes = "" } = {},
) {
  const { requestData, targetUid } = await resolveTargetUid(id);
  const review = buildReview(reviewerUid, notes);

  await update(ref(rtdb, `organizerRequests/${id}`), {
    status: "rejected",
    review,
    rejectedAtMs: Date.now(),
    updatedAtMs: Date.now(),
  });

  await update(ref(rtdb, `users/${targetUid}`), {
    uid: targetUid,
    name: requestData?.organizer?.name || "",
    email: requestData?.organizer?.email || "",
    phone: requestData?.organizer?.phone || "",
    role: "organizer",
    approvalStatus: "rejected",
    active: false,
    updatedAtMs: Date.now(),
  });
}
